export default "__VITE_ASSET__c724cbb6__"